import { Link } from 'react-router';

import { usePluginMessages } from '../../../composition/plugin-runtime';
import { useCompletedActionCount } from '../composition/action-count';

export function HelloWidget() {
  const t = usePluginMessages('hello');
  const count = useCompletedActionCount();
  return (
    <section aria-label="hello 플러그인">
      <p>{t('greeting')}</p>
      <p>
        {t('count')}: {count}
      </p>
      <Link to="/hello">hello 화면</Link>
    </section>
  );
}
